import Image from "next/image";
import { storyblokEditable } from "@storyblok/react/rsc";

import { QuoteIcon } from "@/components/icons/QuoteIcon";
import type { TestimonialStoryblok } from "@/component-types-sb";

type TestimonialProps = {
  blok: TestimonialStoryblok;
};

const Testimonial = ({ blok }: TestimonialProps) => {
  const { text, image, headline, subheadline } = blok.content || blok;

  return (
    <div
      className="flex flex-col justify-between bg-white rounded-2xl px-4 py-6 h-full w-full md:w-[320px]"
      {...storyblokEditable(blok)}
    >
      <div className="flex flex-col md:flex-row gap-3 items-start">
        <QuoteIcon className="shrink-0 w-6 h-6" />
        <p className="text-copy text-black leading-[1.2] min-w-0">{text}</p>
      </div>

      <div className="flex flex-col gap-3 mt-6">
        {image?.filename && (
          <Image
            src={image.filename}
            alt={image.alt || headline || ""}
            width={48}
            height={48}
            className="w-12 h-12 rounded-full object-cover"
          />
        )}
        <div className="text-sm md:text-base text-black leading-[1.2] md:leading-snug">
          {headline && <p className="font-bold">{headline}</p>}
          {subheadline && <p>{subheadline}</p>}
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
